<div>
  <router-outlet></router-outlet>
</div>
<p-toast key="general-notification" [position]="getToastPosition()" [preventOpenDuplicates]="true"></p-toast>